// import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

import Home from './components/Home.js';
import NavBar from './components/NavBar.js';
import Projects from './components/Projects.js';
import Detail from './components/Detail.js';
import Footer from './components/Footer.js';

import { DEFAULT_CHAIN } from './data/metaData.js';

import './App.css';

function App() {
	return (
		<div className="App">
			<Routes>
				<Route path="/:chain" element={<NavBar />}>
					<Route path="" element={<Home />} />
					<Route path="projects" element={<Projects />} />
					<Route path="projects/:tag" element={<Projects />} />
					<Route path="detail/:id" element={<Detail />} />
				</Route>
				<Route
					path="*"
					element={<Navigate to={`/${DEFAULT_CHAIN}`} replace />}
				/>
			</Routes>
			<Footer />
		</div>
	);
}

export default App;
